"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var selectNext = function selectNext(nextStep, getState) {
  if (typeof nextStep === 'string') {
    return nextStep;
  }

  if (typeof nextStep === 'function') {
    return nextStep({
      values: getState().values
    });
  }

  var selectedValue = (0, _get["default"])(getState().values, nextStep.when);
  return nextStep.stepMapper[selectedValue];
};

var _default = selectNext;
exports["default"] = _default;